import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

import translationUK from './translations/uk.json';

const resources = {
  uk: {
    translation: translationUK
  }
};

export const loadLanguageAsync = async (lang) => {
  if (i18n.hasResourceBundle(lang, 'translation')) {
    return;
  }
  if (lang === 'en') {
    const en = await import('./translations/en.json');
    i18n.addResourceBundle('en', 'translation', en.default || en, true, true);
  } else if (lang === 'uk') {
    const uk = await import('./translations/uk.json');
    i18n.addResourceBundle('uk', 'translation', uk.default || uk, true, true);
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'uk',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0
    }
  });

// If initial path starts with /en, load en bundle immediately
if (typeof window !== 'undefined' && window.location.pathname.startsWith('/en')) {
  loadLanguageAsync('en').then(() => {
    i18n.changeLanguage('en');
  });
}

export default i18n;
